import {
  Button,
  ErrorMessage,
  Spinner,
  SuccessPopup,
} from "@/common/components";
import { useContext, useEffect, useState, useCallback } from "@/common/hooks";
import ContactInformation from "@/components/Common/ContactInformation";
import { PrivateContext } from "@/routes/PrivateRoute";
import {
  useSaveInsuranceCompanyForAdminMutation,
  useUpdateInsuranceCompanyForAdminMutation,
} from "@/service/AdminService";
import { useGetStatesForEnrollmentQuery } from "@/service/APIService";

const InsuranceCompanyDetails = () => {
  const {
    setNavHeader,
    location,
    debounceState,
    debounceErrors,
    cancel,
    labels,
    setPageHeader,
  } = useContext(PrivateContext);
  const [contactInfo, setContactInfo] = useState({
    addressStateCountry: {},
  });
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const {
    data: states,
    isFetching: isFetching,
    error: error,
  } = useGetStatesForEnrollmentQuery();

  const [updateInsuranceCompanyApi, { isLoading: isFetching1, error: error1 }] =
    useUpdateInsuranceCompanyForAdminMutation();

  const [saveInsuranceCompanyApi, { isLoading: isFetching2, error: error2 }] =
    useSaveInsuranceCompanyForAdminMutation();

  const checkDisabled = useCallback(() => {
    let disable = false;

    Object.keys(errors).forEach((e) => {
      if (errors[e]) {
        disable = true;
      }
    });

    if (disable) {
      return true;
    }

    const requiredFields = [
      "name",
      "addressLine1",
      "city",
      "zipCode",
      "phoneNumber",
    ];

    requiredFields.forEach((e) => {
      if (!contactInfo[e]) {
        disable = true;
      }
    });

    return disable;
  }, [errors]);

  const addOrUpdateInsuranceDetails = () => {
    // Update
    if (location?.state) {
      updateInsuranceCompanyApi(contactInfo)
        .unwrap()
        .then((res) => {
          if (!res.errors.length) {
            setShowPopup(true);
          }
        });
    }
    // Add New
    else {
      saveInsuranceCompanyApi(contactInfo)
        .unwrap()
        .then((res) => {
          if (!res.errors.length) {
            setShowPopup(true);
          }
        });
    }
  };

  useEffect(() => {
    setPageHeader(labels?.insuranceCompany?.insuranceCompanyDetails);
    setNavHeader(labels?.insuranceCompany?.navHeader);

    if (location?.state) {
      setContactInfo(location?.state);
    }
  }, []);

  return (
    <section className="container-medium py-5">
      {(isFetching || isFetching1 || isFetching2) && <Spinner />}
      <ErrorMessage error={error || error1 || error2} wrapperClassName="mb-3" />
      {location?.state && (
        <div className="mb-3">
          {labels?.insuranceCompany?.insurerId} {contactInfo?.id}
        </div>
      )}
      <ContactInformation
        showHeading={false}
        showNames={false}
        showCompanyName={true}
        showWebsite={true}
        showServerHost={true}
        showCellPhone={false}
        showEmail={false}
        showExtension={false}
        contactInfo={contactInfo}
        setContactInfo={setContactInfo}
        states={states}
        errors={errors}
        setErrors={setErrors}
        touched={touched}
        setTouched={setTouched}
        debounceErrors={debounceErrors}
        debounceState={debounceState}
        labels={labels?.insuranceCompany}
      />

      <div className="d-flex flex-row gap-1 justify-content-end mt-5">
        <Button
          id="cancel"
          type="secondary"
          text={labels?.insuranceCompany?.cancel}
          wrapperClassName="col-md-4 col-6"
          click={cancel}
        />
        <Button
          id="done"
          text={
            location?.state
              ? labels?.insuranceCompany?.update
              : labels?.insuranceCompany?.submit
          }
          wrapperClassName="col-md-4 col-6"
          disabled={checkDisabled()}
          click={addOrUpdateInsuranceDetails}
        />
      </div>
      <SuccessPopup
        showModal={showPopup}
        buttonText={labels?.insuranceCompany?.continue}
        click={cancel}
        body={labels?.insuranceCompany?.requestCompleted}
      />
    </section>
  );
};

export default InsuranceCompanyDetails;
